module.exports = __webpack_public_path__ + "static/media/rev_tec.3983853b.svg";